import React, { useEffect } from 'react';
import styled from "styled-components";
import Calendar from '@shared/ui/molecules/calendar/Calendar';
import moment, { Moment } from "moment";
import { useDispatch, useSelector } from "react-redux";
import { NumberOfPeopleOption } from "./NumberOfPeopleOption";
import {
  refreshBookings,
  selectedOffice,
  selectIsSidebarOpen,
  setOffice,
  setSidebarOpen
} from "../models/room-finder.duck";
import { MeetingRoomFacilitiesOptions } from "./MeetingRoomFacilitiesOptions";
import { FloorFilterOption } from "./FloorFilterOption";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { selectActiveDay, setActiveDay } from '@features/whereabouts/store/editMovements.duck';
import { selectAllRootOffices } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { addOrReplaceQueryParam } from '@shared/utils/UrlUtils';
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { OfficeDropDownList } from '@shared/ui/organisms/OfficeDropDownList';
import { FloatingSidebar } from "@features/whereabouts/pages/company-movements/components/ViewComponents";
import { MicrosoftCalendarSyncActiveIndicator } from '@shared/ui/organisms/MicrosoftCalendarSyncActiveIndicator';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import isMobile from "is-mobile";
import { desktopSmall } from '@shared/ui/atoms/MediaQueries';

export function RoomFinderSidebar(props: Props) {
  const dispatch = useDispatch();
  const calendarDate = useSelector(selectActiveDay);
  const office = useSelector(selectedOffice);
  const allOfficesForMeetingRooms = useSelector(selectAllRootOffices);
  const isSideBarOpen = useSelector(selectIsSidebarOpen);

  const onOfficeSelected = (office: OfficeEntity) => {
    dispatch(setOffice(office));
  }

  const onDateSelected = (date: Moment) => {
    addOrReplaceQueryParam('date', date.format(DATE_FORMAT))
    dispatch(setActiveDay(date));
    dispatch(refreshBookings())
  }

  useEffect(() => {
    if (isMobile()) {
      dispatch(setSidebarOpen(false));
    }
  }, [dispatch]);

  return (
    <Sidebar className={'roomFinderView__sidebar roomFinderView__sidebar--open'} isOpen={isSideBarOpen}>
      <HeadlineSmall className={'roomFinderSidebar__title'}>Filter rooms</HeadlineSmall>
      <IconButton icon={IconTypes.Close}
                  size={"large"} className={"sidebar__closeBtn roomFinderSidebar__closeBtn"}
                  onClick={() => dispatch(setSidebarOpen(false))} />
      <Calendar onDateSelect={onDateSelected}
                className={'calendar__roomFinderSidebar'}
                initialDate={calendarDate ?? moment()}
                activeDate={calendarDate} style={{margin: '0 auto 24px auto'}} />
      <OfficeDropDownListWrapper>
        <BodyRegular weight={700} style={{marginBottom: 8}}>Choose an office</BodyRegular>
        <OfficeDropDownList onSelect={onOfficeSelected} offices={allOfficesForMeetingRooms} disabled={false} preSelectedOffice={office?.id} />
      </OfficeDropDownListWrapper>
      <FloorFilterOption />
      <NumberOfPeopleOption />
      <MeetingRoomFacilitiesOptions style={{margin: '20px 0'}} />
      <MicrosoftCalendarSyncActiveIndicator />
    </Sidebar>
  )
}

interface Props {
}

const OfficeDropDownListWrapper = styled.div`
  margin: 20px 0;
  width: 100%;
`

const Sidebar = styled(FloatingSidebar)<any>`
  height: 100%;
  position: absolute;
  display: ${props => props.isOpen ? 'block' : 'none'};
  @media (${desktopSmall}) {
    position: relative;
    display: block !important;
  }
  .roomFinderSidebar__closeBtn {
    top: 16px;
    right: 16px;
    position: absolute;
  }
`
